import { Record } from 'immutable';

export default class QualifyingDeductionRecord extends Record({
  id: undefined,
  averageHourlyFee: undefined,
  createdAt: undefined,
  createdBy: undefined,
  hoursPerWeek: undefined,
  links: undefined,
  validFrom: undefined,
}) {
}
